<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="销货单"
      edit-title
      id-key="commentId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.list"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="DocNo">
              <!-- <el-input
                v-model="data.DocNo"
                placeholder="请输入单据编号"
                v-if="noEdit"
              ></el-input> -->
              <span>{{ data.DocNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <!-- <el-date-picker
                size="mini"
                v-model="data.DocDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :editable="false"
              ></el-date-picker> -->
              <span>{{ data.DocDate }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户名称" prop="CustomerId">
              <!-- <el-select v-model="data.CustomerId" size="mini" :disabled="true" style="width:220px;">
                <el-option v-for="item in cList" :key="item.WholesalerId" :value="item.WholesalerId" :label="item.WholesalerName"></el-option>
              </el-select> -->
              <span>{{ data.CustomerName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="销售单号" prop="OrderNo">
              <!-- <el-input v-model="data.OrderNo" placeholder="请选择销售单号" readonly @focus="addSa" :disabled="true" style="width:220px">
              </el-input> -->
              <span>{{ data.OrderNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款条件" prop="ReceiptConditionId">
              <!-- <el-select size="mini" v-model="data.ReceiptConditionId" :disabled="true" placeholder="请选择" clearable>
                <el-option v-for="item in recCon" :key="item.ReceiptConditionId" :label="item.ReceiptConditionName" :value="item.ReceiptConditionId"></el-option>
            </el-select> -->
              <span>{{ data.ReceiptConditionName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="票据类型" prop="InvoiceType">
              <!-- <el-select size="mini" v-model="data.InvoiceType" :disabled="true" placeholder="请选择" clearable style="width:220px;">
                <el-option :value="0" label="不开票" />
                <el-option :value="1" label="从发票类型中提取" />
                <el-option :value="2" label="其它票据" />
            </el-select> -->
              <span>{{ data.InvoiceType==0?"不开票":(data.InvoiceType==1?"从发票类型中提取":"其他票据") }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发票号码" prop="InvoiceNo">
              <!-- <el-input v-model="data.InvoiceNo" :disabled="true" placeholder="请输入发票号码"></el-input> -->
              <span>{{ data.InvoiceNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发票金额" prop="InvoiceAmount">
              <!-- <el-input v-model="data.InvoiceAmount" :disabled="true" placeholder="请输入发票金额"></el-input> -->
              <span>{{ data.InvoiceAmount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交货方式">
              <!-- <el-select size="mini" v-model="data.FreightMode" :disabled="true" placeholder="请选择">
                <el-option label="异地配送" :value="0"></el-option>
                <el-option label="本地配送" :value="1"></el-option>
                <el-option label="自提" :value="2"></el-option>
              </el-select> -->
              <span>{{ data.FreightMode==0?"异地配送":(data.FreightMode==1?"本地配送":"自提") }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务员" prop="ClerkName">
              <!-- <el-input v-model="data.ClerkName" @focus="addEmp" :disabled="true" readonly style="width:220px;"></el-input> -->
              <span>{{ data.ClerkName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="物流公司" prop="BrandCode">
              <!-- <el-input v-model="data.BrandCode" :disabled="true"></el-input> -->
              <span>{{ data.BrandCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="物流费用" prop="ActualFreight">
              <span>{{data.ActualFreight}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <!-- <el-input
                type="textarea"
                v-model="data.Remark"
                :disabled="true"
                placeholder="请输入备注"
              ></el-input> -->
              <span>{{ data.Remark }}</span>
            </el-form-item>
          </el-col>
          <dialog-list ref="dialogList" :info="data" @getList="getList" />
        </el-row>
        <el-col :span="6">
            <el-form-item label="无税金额" prop="NoTaxAmount">
              <span>{{ data.NoTaxAmount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税额" prop="TaxAmount">
              <span>{{ data.TaxAmount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单金额" prop="Amount">
              <span>{{ data.Amount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款金额" prop="ReceiptAmount">
              <span>{{ data.ReceiptAmount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="剩余金额" prop="RemainAmount">
              <span>{{ data.RemainAmount }}</span>
            </el-form-item>
          </el-col>

          <el-row>
            <el-row>
              <el-col :span="24">
                <el-divider />
                <span style="margin-left: 16px; line-height: 50px"
                  >收款信息</span
                >
                <!-- <el-button
                  type="primary"
                  icon="el-icon-plus"
                  size="mini"
                  circle
                  @click="add"
                  style="float: right; margin: 10px 15px 10px 0"
                ></el-button> -->
              </el-col>
            </el-row>
            <el-row v-for="(item, index) in recList" :key="index">
              <el-col :span="6">
                <el-form-item label="结算方式" prop="SettleId">
                  <!-- <el-select
                    size="mini"
                    v-model="item.SettleId"
                    placeholder="请选择"
                    clearable
                    :disabled="true"
                  >
                  <el-option v-for="set in settleList" :key="set.SettleId" :label="set.SettleName" :value="set.SettleId"></el-option>
                  </el-select> -->
                  {{item.Settle}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="收款账号" prop="AccountId">
                  <!-- <el-select
                    :disabled="true"
                    size="mini"
                    v-model="item.AccountId"
                    placeholder="请选择"
                    clearable
                  >
                  <el-option v-for="acc in accountList" :key="acc.AccountId" :label="acc.AccountName" :value="acc.AccountId"></el-option>
                  </el-select> -->
                  {{item.Account}}
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="收款金额" prop="ReceiptAmount">
                  <!-- <el-input v-model="item.ReceiptAmount" type="number" @input="recChange(index)"></el-input> -->
                  {{item.ReceiptAmount}}
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <!-- <el-link :underline="false" @click="del(index)"
                  ><i
                    class="el-icon-delete"
                    style="
                      margin-left: 30px;
                      line-height: 30px;
                      font-size: 18px;
                    "
                  ></i
                ></el-link> -->
              </el-col>
            </el-row>
          </el-row>
      </template>
      <template slot="footer">
        <!-- <el-button size="mini" type="danger" @click="cancelExamine" v-if="data.Status==2&&canExa">弃 审</el-button>
        <el-button size="mini" type="danger" @click="examine" v-else-if="canExa">审 核</el-button> -->
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <sa-dialog ref="saDialog" in-dialog selectable @select="setSa" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dialogList from "./dialogList";
import saDialog from "@/components/sales/business/salesorder/saListDialog";
import empDialog from "@/components/sales/business/empDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    saDialog,
    empDialog
  },
  data() {
    return {
      data: {
        DocId: 0,
        DocNo: "",
        DocDate: "",
        // SaDocId: 0,
        CustomerId: "",
        CustomerType: 1,
        SaDocNo: "",
        InvoiceType: null,
        InvoiceNo: "",
        InvoiceAmount: "",
        FreightMode: 0,
        Remark: "",
        ActualFreight: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        ReceiptAmount: 0,
        Amount: 0,
        RemainAmount: 0,
        ReceiptConditionId: 0,
        ClerkName: "",
        ClerkId: 0,
        OrderNo: "",
        OrderId: 0,
        Status: 0,

        ShowTax: 0,
        OutStatus: 0,
        CompleteStatus: 0,
        ReceiptStatus: 0,
        InvoiceStatus: 0,
      },
      canExa: false,
      noEdit: false,
      recList: [],
      tableData: [],
      accountList: [],
      settleList: [],
      recCon: [],
      recDel: [],
      cList: [],
      api: require("@/api/sale/saDoc").default,
      recApi: require("@/api/sy/RecCon").default,
      settleApi: require("@/api/sale/settle").default,
      accountApi: require("@/api/sale/account").default,
      billApi: require("@/api/sy/bill").default,
      rules: {
        OrderNo: [{ required: true, message: "销售单号不能为空" }],
        InvoiceType: [{ required: true, message: "票据类型不能为空" }],
        ClerkName: [{ required: true, message: "业务员不能为空" }],
        CustomerId: [{ required: true, message: "客户名称不能为空" }],
        InvoiceNo: [{ required: true, message: "发票号码不能为空" }],
        InvoiceAmount: [{ required: true, message: "发票金额不能为空" }],
      },
    };
  },
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime());
    let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
    if(!this.data.DocDate) {
      this.data.DocDate = today
    }
    this.settleApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.settleList = res.Data
    })
    this.accountApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.accountList = res.Data
    })
    this.recApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.recCon = res.Data
    })
  },
  methods: {
    addSa() {
      this.$refs.saDialog.open().then((that) => {
        that.getData();
      });
    },
    setSa(e) {
      
      this.data.OrderNo = e.OrderNo
      this.data.OrderId = e.OrderId
      this.$refs.dialogList.getData()
    },
    getList(list) {
      this.tableData = list
      let Amount = null
      let TaxAmount = null
      let ReceiptAmount = this.data.ReceiptAmount || 0
      list.forEach(item => {
        if(item.T !=2) {
          Amount += Number(item.Amount)
          TaxAmount += Number(item.TaxAmount)
        }
      })
      this.data.Amount = Amount
      this.data.TaxAmount = TaxAmount
      this.data.NoTaxAmount = Amount - TaxAmount
      this.data.RemainAmount = ReceiptAmount - Amount
    },
    recChange(index,type) {
      let ReceiptAmount = 0
      let Amount = this.data.Amount
      if(!Amount) {
        Amount = 0
      }
      this.recList.forEach(item => {
        if(item.ReceiptAmount) {
          ReceiptAmount += Number(item.ReceiptAmount)
        }
      })
      if(type!="del") {
        if(this.recList[index].T !== 0 ) {
          this.recList[index].T = 1
        }
      }
      this.data.ReceiptAmount = Number(ReceiptAmount)
      this.data.RemainAmount = this.data.ReceiptAmount - Amount
    },
    add() {
      this.recList.push({
        T: 0, 
        DocReceiptId: 0,
        OrderReceiptId: 0,
        OrderId: this.data.OrderId,
        SettleId: null,
        AccountId: null,
        ReceiptAmount: 0,
        AddTime: this.data.DocDate
      });
    },
    del(index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if(this.recList[index].T!==0) {
          this.recList[index].T = 2
          this.recDel.push(this.recList[index])
        }
        this.recList.splice(index, 1)
        this.recChange(index,"del")
      });
    },
    addEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId
      this.data.ClerkName = e.EmpName
    },
    examine() {
      this.$confirm("确认审核数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.examine(this.data.DocId).then(res => {
          if(res.Code ==0) {
            this.$message.success("审核成功")
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm("确认弃审数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.cancelExamine(this.data.OrderId).then(res => {
          if(res.Code ==0) {
            this.$message.success("弃审成功")
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    onCreateOpened() {
      this.canExa = false
      this.cList = JSON.parse(sessionStorage.getItem("cList"))
      this.$refs.dialogList.tableData = []
      this.$refs.dialogList.tableDel = []
      this.billApi.getDefaultSerialNo("销货单").then(res => {
        if(res.Code==0&&res.Data) {
          this.data.DocNo = res.Data
        } else if(res.Code==0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    onEditOpened() {
      this.canExa = true
      this.$refs.dialogList.tableData = []
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.getData()
      this.cList = JSON.parse(sessionStorage.getItem("cList"))
      if(this.data.ReceiptConditionId == 0) {
        this.data.ReceiptConditionId = null
      }
      this.api.getReceiptList(this.data.DocId).then(res => {
        res.Data.forEach(item => {
          if(item.SettleId == 0) {
            item.SettleId = null
          }
          if(item.AccountId == 0) {
            item.AccountId = null
          }
        })
        this.recList = res.Data
      })
    },
    onBeforeSave() {
      let tableData = this.$refs.dialogList.tableData;
      let tableDel = this.$refs.dialogList.tableDel;
      if(tableData.length==0) {
        this.$message.error("请填写商品列表");
        return false
      }
      let tb = []
      if(tableData.length==0) {
        this.$message.error("请填写商品列表");
        return false;
      }
      for(var i = 0; i < tableData.length; i++) {
        if(!tableData[i].GoodsName) {
          this.$message.error("请选择商品");
          return false;
        }
        if(!tableData[i].Quantity) {
          this.$message.error("请填写数量");
          return false;
        }
        if(tableData[i].T===0||tableData[i].T===1) {
          tb.push(tableData[i])
        }
      }
      this.data.Goods = tb.concat(tableDel)
      if(!this.data.RemainAmount&&this.data.RemainAmount!==0||this.recList.length==0) {
        this.$message.error("请填写收款信息");
        return false
      }
      if(this.data.ReceiptConditionId===null) {
        this.data.ReceiptConditionId = 0
      }
      let rec = []
      this.recList.forEach(item => {
        if(item.T||item.T===0) {
          rec.push(item)
        }
      })
      this.data.Receipts = rec.concat(this.recDel)
      this.data.Receipts.forEach(item => {
        if(!item.SettleId) {
          item.SettleId = 0
        }
        if(!item.AccountId) {
          item.AccountId = 0
        }
      })
      
      return true
    },
  },
};
</script>